const devApi = {
    "aws_project_region": "us-east-1",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": process.env.REACT_APP_DEV_AWS_USER_POOLS_ID,
    "aws_user_pools_web_client_id": process.env.REACT_APP_DEV_AWS_USER_POOLS_WEB_CLIENT_ID,
    "aws_appsync_graphqlEndpoint": "https://dev-saas-api.ieqmax.io/graphql",
    // "aws_appsync_graphqlEndpoint": "https://hoeimztvljh4hcpqr4ychy2ydq.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": null,
    // "authenticationFlowType": 'CUSTOM_AUTH',
    "oauth": {
        "domain": "devieqmax.auth.us-east-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        // "redirectSignIn": "http://localhost:3000",
        // "redirectSignOut": 'http://localhost:3000',
        "redirectSignIn": "https://dev.ieqmax.io",
        "redirectSignOut": 'https://dev.ieqmax.io',
        "responseType": "code",

    },
    "federationTarget": "COGNITO_USER_POOLS"
};

const qaApi = {
    "aws_project_region": "us-east-1",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": process.env.REACT_APP_QA_AWS_USER_POOLS_ID,
    "aws_user_pools_web_client_id": process.env.REACT_APP_QA_AWS_USER_POOLS_WEB_CLIENT_ID,
    "aws_appsync_graphqlEndpoint": "https://akupkwclx5f77lr2r2abjnt5vq.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": null,
    "oauth": {
        "domain": "qaieqmax.auth.us-east-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://qa.ieqmax.io",
        "redirectSignOut": "https://qa.ieqmax.io",
        "responseType": "code",
    },
    "federationTarget": "COGNITO_USER_POOLS"
};
const prodApi = {
    "aws_project_region": "us-east-1",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": process.env.REACT_APP_PROD_AWS_USER_POOLS_ID,
    "aws_user_pools_web_client_id": process.env.REACT_APP_PROD_AWS_USER_POOLS_WEB_CLIENT_ID,
    "aws_appsync_graphqlEndpoint": "https://ps6yu4epffgfdc4fm55fdm2sfm.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": null,
    "oauth": {
        "domain": "appieqmax.auth.us-east-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://app.ieqmax.io",
        "redirectSignOut": 'https://app.ieqmax.io',
        "responseType": "code",

    },
    "federationTarget": "COGNITO_USER_POOLS"
};

const devApiMeasurementService = {
    "aws_project_region": "us-east-1",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": process.env.REACT_APP_DEV_AWS_USER_POOLS_ID,
    "aws_user_pools_web_client_id": process.env.REACT_APP_DEV_AWS_USER_POOLS_WEB_CLIENT_ID,
    // "aws_appsync_graphqlEndpoint": "https://ovqf4lp7xrgaholdgipeypzjdq.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_graphqlEndpoint": "https://dev-api.ieqmax.io/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": null,
};
const qaApidevApiMeasurementService = {
    "aws_project_region": "us-east-1",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": process.env.REACT_APP_QA_AWS_USER_POOLS_ID,
    "aws_user_pools_web_client_id": process.env.REACT_APP_QA_AWS_USER_POOLS_WEB_CLIENT_ID,
    // "aws_appsync_graphqlEndpoint": "https://5vm3i2y6irfhxmyytfjbp6us2i.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_graphqlEndpoint": "https://qa-api.ieqmax.io/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": null,
};

const prodApiMeasurementService = {
    "aws_project_region": "us-east-1",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": process.env.REACT_APP_PROD_AWS_USER_POOLS_ID,
    "aws_user_pools_web_client_id": process.env.REACT_APP_PROD_AWS_USER_POOLS_WEB_CLIENT_ID,
    "aws_appsync_graphqlEndpoint": "https://api.ieqmax.io/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": null,
};

export { devApi, qaApi, prodApi, devApiMeasurementService, qaApidevApiMeasurementService, prodApiMeasurementService };
